export const bornDate = (age: number): string => {
  const today = new Date().toISOString().slice(0, 10).split('-')
  const year = (Number(today[0]) - age).toString()

  return `${year}-${today[1]}-${today[2]}`
}

export const getToday = (): string => new Date().toISOString().split('T')[0]

export const daysAgo = (days: number): string => {
  const d = new Date()
  d.setDate(d.getDate() - Math.abs(days))
  return d.toISOString().split('T')[0]
}

export const daysAfter = (refDate: string, days: number): string => {
  const today = new Date()
  const d = new Date(refDate)
  d.setDate(d.getDate() + Math.abs(days))
  return d > today ? getToday() : d.toISOString().split('T')[0]
}

export const GetDateFormatted = (date: string | Date): string => {
  return new Date(date).toLocaleDateString('es-ES', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  })
}

export const GetDateFormattedLong = (date: string | Date): string => {
  return new Date(date).toLocaleDateString('es-ES', {
    day: '2-digit',
    month: 'long',
    year: 'numeric',
  })
}

//Porque el .toISOString resta 1 dia
export const ConvertDateToISOPlusOne = (date?: Date): string => {
  if (date) {
    date.setDate(date.getDate() + 1)
    return date.toISOString()
  }
  return ''
}

export const isValidDate = (date: string | undefined): boolean => {
  if (!date) return false
  const parsedDate = new Date(date)
  return !isNaN(parsedDate.getTime())
}
